module.exports = __webpack_public_path__ + "img/3d-rotate-icon.59eba0e0.png";